module.exports = __webpack_public_path__ + "static/media/mario-base.57332521.svg";